var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-action",class:{ 'spinner-active': _vm.isSpinner }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border text-dark icon-spinner",attrs:{"role":"status","tabindex":"0"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }